class GorgiasChatButton extends HTMLElement {
  button = this.querySelector('button');
  chatLastOpenedDate = localStorage.getItem('gorgias.chat-last-opened-date');

  // Gorgias IDs for each shift
  dayShiftId = '01JTTMVS94SKMMXYP05HXY7JC2';
  nightShiftId = '01JXD0PTWTYQEN5DQSPPP6XVJX';
  dayShiftCvtId = '791bbde8-ed46-4aee-a3a7-04f3cc788459';
  nightShiftCvtId = '32835258-1be9-4967-8a1b-2f5278fc4ad2';

  connectedCallback() {
    // If the chat was opened previously, open it immediately
    if (this.chatLastOpenedDate) return this.addGorgiasScripts();

    // If the chat was not opened previously, add the event listener to open it when the button is clicked
    this.button.addEventListener('click', () => this.addGorgiasScripts());
  }

  getActiveShift() {
    const now = new Date();
    const currentTime = now.getHours() * 60 + now.getMinutes();

    const dayShiftStart = this.parseTimeToMinutes(this.dataset.dayShiftStart);
    const dayShiftEnd = this.parseTimeToMinutes(this.dataset.dayShiftEnd);
    const nightShiftStart = this.parseTimeToMinutes(this.dataset.nightShiftStart);
    const nightShiftEnd = this.parseTimeToMinutes(this.dataset.nightShiftEnd);

    // Determine which shift is currently active
    if (this.isTimeInRange(currentTime, dayShiftStart, dayShiftEnd)) {
      return 'day';
    } else if (this.isTimeInRange(currentTime, nightShiftStart, nightShiftEnd)) {
      return 'night';
    }

    // Default to day shift if outside both ranges
    return 'day';
  }

  /**
   * Parse a time string in the format "HH:MM" to minutes since midnight
   * @param {string} timeString - The time string to parse
   * @returns {number} The number of minutes since midnight
   */
  parseTimeToMinutes(timeString) {
    if (!timeString) return 0;
    const [hours, minutes] = timeString.split(':').map(Number);
    return hours * 60 + minutes;
  }

  /**
   * Check if a current time is within a given time range
   * @param {number} currentTime - The current time in minutes since midnight
   * @param {number} startTime - The start time in minutes since midnight
   * @param {number} endTime - The end time in minutes since midnight
   * @returns {boolean} True if the current time is within the range, false otherwise
   */
  isTimeInRange(currentTime, startTime, endTime) {
    if (startTime <= endTime) {
      // Same day range (e.g., 9:00 to 17:00)
      return currentTime >= startTime && currentTime <= endTime;
    }
    // Overnight range (e.g., 22:00 to 06:00)
    return currentTime >= startTime || currentTime <= endTime;
  }

  /**
   * Get the ID of the active shift
   * @returns {string} The ID of the active shift
   */
  getActiveShiftId() {
    const activeShift = this.getActiveShift();
    return activeShift === 'day' ? this.dayShiftId : this.nightShiftId;
  }

  /**
   * Get the ID of the active CVT
   * @returns {string} The ID of the active CVT
   */
  getActiveCvtId() {
    const activeShift = this.getActiveShift();
    return activeShift === 'day' ? this.dayShiftCvtId : this.nightShiftCvtId;
  }

  /**
   * Add the Gorgias scripts to the page
   */
  addGorgiasScripts() {
    this.addWidgetScript();
    this.addBundleScript();

    // Listen for the widget to be loaded
    window.addEventListener('gorgias-widget-loaded', () => {
      // Open the chat
      window.GorgiasChat.open();

      // Remove the button from the DOM
      setTimeout(() => this.remove(), 500);
    });
  }

  /**
   * Add the Gorgias widget script to the page
   */
  addWidgetScript() {
    const gorgiasScript = document.createElement('script');
    gorgiasScript.id = 'gorgias-chat-widget-install-v3';
    gorgiasScript.src = `https://config.gorgias.chat/bundle-loader/${this.getActiveShiftId()}`;
    document.head.appendChild(gorgiasScript);
  }

  /**
   * Add the Gorgias bundle script to the page
   */
  addBundleScript() {
    const bundleScript = document.createElement('script');
    bundleScript.src = `https://bundle.dyn-rev.app/loader.js?g_cvt_id=${this.getActiveCvtId()}`;
    bundleScript.async = true;
    document.head.appendChild(bundleScript);
  }
}

customElements.define('gorgias-chat-button', GorgiasChatButton);
